
import stringMixin from './stringMixin';

export default {
  name: 'XhInput', // 新建 input
  components: {},
  mixins: [stringMixin],
  props: {},
  data: function data() {
    return {};
  },

  computed: {
    type: function type() {
      var data = this.item && this.item.data ? this.item.data : this.item;
      if (this.item && data.formType == 'password') {
        return data.formType;
      } else if (this.item && (data.formType == 'floatnumber' || data.formType == 'number')) {
        return 'number';
      } else {
        return 'text';
      }
    },
    inputLimitType: function inputLimitType() {
      var data = this.item && this.item.data ? this.item.data : this.item;
      if (this.item && data.formType == 'number') {
        return 'number';
      }

      return null;
    },
    isAutoNumber: function isAutoNumber() {
      var data = this.item && this.item.data ? this.item.data : this.item;
      if (this.item && data.autoGeneNumber) {
        return data.autoGeneNumber == 1;
      }
      return false;
    },
    placeholder: function placeholder() {
      return this.isAutoNumber ? '根据编号规则自动生成，支持手动输入' : '';
    }
  },
  watch: {},
  mounted: function mounted() {},

  methods: {}
};